import { action } from '@/lib/api.js';

const setArgumentOptionSlider = ({ open = true, isTransformAction = false, isMapStep = false, ...args }) => {
  action('SET_ARGUMENT_OPTION_SLIDER', { open, isTransformAction, isMapStep, ...args });
};

export default setArgumentOptionSlider;
